export default __webpack_public_path__ + "static/media/cderp.004763c4.jpg";